import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { IAuroraState } from '@apps/aurora.state';
import { Profile } from '@apps/auth/models';
import { getUsersInternalProfile } from '@apps/back/store/auth/users/internal/users-internal.selectors';
import { IdenticonService } from '@apps/auth/api/identicon.service';
@Component({
    selector: 'aa-user-icon',
    templateUrl: './user-icon.component.html',
    styleUrls: ['./user-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserIconComponent implements OnInit
{
    @Input() userName: string;
    @Input() size: string = '32px';
    @Input() withBg: boolean = true;

    public loading: boolean = false;
    public alt: string = '';
    public src: Observable<string> = of('./assets/images/AurorA.png');
    public user: Observable<Profile>;

    constructor (
        private store: Store<IAuroraState>,
        private identiconService: IdenticonService
    )
    {}

    ngOnInit ()
    {
        this.user = this.store.select(getUsersInternalProfile, { userName: this.userName })
            .pipe(
                tap(user =>
                {
                    if (user?.email)
                    {
                        this.loading = true;
                        this.src = this.identiconService.getDataUrl(user?.email)
                            .pipe(
                                finalize(() =>
                                    this.loading = false
                                )
                            );
                    }
                })
            );
    }
}
